import classNames from 'classnames'

import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { AIButton } from '../AIButton'
import { AIButtonIconGradientIdPrefix } from '../AIButton.constants'

import * as styles from './AIButtonOutlined.module.css'

function AIButtonOutlined({
  className = styles.aiButtonOutlined,
  height = BUTTON_HEIGHT_32,
  isSkeleton,
  textClassName = styles.aiButtonOutlinedLabel,
  ...restProps
}) {
  return (
    <AIButton
      {...restProps}
      Button={Button.Outlined}
      className={classNames(className, {
        [styles.skeleton]: isSkeleton,
      })}
      gradientIdPrefix={AIButtonIconGradientIdPrefix.Outlined}
      height={height}
      isSkeleton={isSkeleton}
      textClassName={textClassName}
    />
  )
}

export default AIButtonOutlined
